<template>
	<div class="card card-shape home-box">
		<div class="card-header d-flex flex-row align-items-center justify-content-between">
			<h6 class="m-0 fw-bold text-green">{{ payOnly ? 'Pay commission (Excel)' : 'Commission Imports' }}</h6>
			<b-link
				v-b-tooltip.hover="{ variant: 'info' }"
				title="Download the Excel template for commission upload"
				aria-label="Download Excel template"
				@click="downloadFile"
				class="fw-semibold ms-2 akkurate-green"
			>
				<font-awesome-icon :icon="['fas', 'download']" aria-hidden="true" />
				<span class="visually-hidden">Download template</span>
			</b-link>
		</div>
		<div class="card-body">
			<div class="err-accounts text-center my-2">
				<errors v-if="message">
					{{ message }}
				</errors>
			</div>
			<div class="card card-shape home-box mb-3 border border-success">
				<div class="card-body py-2">
					<div class="row mb-3">
						<div class="col-md-9">
							<div class="row">
								<div class="col-3">
									<label class="akkurate-dark small" for="phone">Choose File<star> </star></label>
									<input type="file" class="form-control mt-2" @change="handleFileUpload"
										ref="fileInput" accept=".xlsx,.xls,.xlt,.xltm,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
								</div>
								<div class="col-3">
									<label class="akkurate-dark small" for="excel_upload_id">Excel Upload Ref:<star>
										</star></label>
									<b-form-group id="excel_upload_id" label-for="excel_upload_id"
										class="akkurate-dark">
										<b-form-input id="excel_upload_id" class="mt-2 field-container fields"
											type="text" v-model="form.excel_upload_id"
											placeholder="Enter Excel Upload ID">
										</b-form-input>
									</b-form-group>
								</div>
								<div class="col mt-auto">
									<label class="akkurate-dark small" for="total_count">
										Records</label>
									<div class="mt-2">{{ total_count }}</div>
								</div>
								<div class="col mt-auto">
									<label class="akkurate-dark small" for="total_count">Amount
									</label>
									<div class="mt-2">
										GHS {{ displayNumber(total_amount) }}
									</div>
								</div>
								<div class="col mt-auto" v-if="!payOnly">
									<!-- <label class="akkurate-dark small" for="total_a">Action</label> -->
									<b-form-checkbox class="small" v-model="form.submit_commission"
										name="commission_action" value="submit_commission">
										Submit
									</b-form-checkbox>
									<b-form-checkbox class="small" v-model="form.pay_commission"
										name="commission_action" value="pay_commission">
										Pay
									</b-form-checkbox>
								</div>
								<div class="col mt-auto small akkurate-dark" v-else>
									Action: <strong>Pay commission</strong> (execution)
								</div>
							</div>
						</div>
						<div class="col mt-auto">
							<b-button
								:disabled="isSaving"
								class="btn-size w-75 akkurate-green-btn text-white"
								v-b-tooltip.hover="{ variant: 'info' }"
								:title="payOnly ? 'Upload the Excel file and execute commission payment' : 'Upload and process the commission import file'"
								:aria-label="payOnly ? 'Upload and pay commission' : 'Import commission'"
								@click="saveBulkDeposit"
							>
								<font-awesome-icon class="small me-1" :icon="['fas', 'upload']" aria-hidden="true" />
								{{ payOnly ? 'Upload & pay' : 'Import Commission' }}
							</b-button>
						</div>
					</div>
				</div>
			</div>

			<div v-if="!payOnly" class="row">
				<div class="col-md-12">
					<vue-good-table styleClass="vgt-table bordered striped" mode="remote" ref="allAccountTable"
						:columns="account_columns" :rows="account_rows" :isLoading.sync="isLoading"
						:totalRows="totalRecords" :select-options="{
							enabled: true,
							disableSelectInfo: true, // disable the select info panel on top
						}">
					</vue-good-table>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import Footer from "@/views/main/components/Footer.vue";
import ApiService from "@/core/services/api.service";
import config from "@/config.js";
import * as XLSX from "xlsx";
import Multiselect from "vue-multiselect";

export default {
	props: {
		/** When true: only pay flow — sends pay_commission, no submit_commission (dedicated Pay commission page). */
		payOnly: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		SidebarView,
		TopbarView,
		Footer,
		Multiselect,
	},
	data() {
		return {
			...this.initialState(),
			message: null,

			// jsonData:null,
			account_columns: [
				{
					label: "A/C",
					field: "account_number",
				},
				{
					label: "Comission",
					field: "commission",
				},
				{
					label: "Commission frequency",
					field: "commission_frequency",
				},
				{
					label: "Commission start date",
					field: "commission_start_date",
				},
			],
			account_types_options: [],
			account_type: "",
			account_rows: [],
			serverParams: {
				// a map of column filters example: {name: 'john', age: '20'}
				columnFilters: {},
				sort: [
					{
						field: "", // example: 'name'
						type: "", // 'asc' or 'desc'
					},
				],
				page: 1, // what page I want to show
				perPage: 20, // how many items I'm showing per page
			},
		};
	},
	created() {
		if (this.payOnly) {
			this.isLoading = false;
		}
	},
	methods: {
		parseDate(dateString) {
			const parts = dateString.split("/");
			// parts[0] is the day, parts[1] is the month, parts[2] is the year
			return new Date(parts[2], parts[1] - 1, parts[0]); // month is 0-based
		},
		handleFileUpload(event) {
			this.excelFile = event.target.files[0];
			this.total_amount = 0;
			this.total_count = 0;
			this.account_rows = [];
			if (this.excelFile) {
				const reader = new FileReader();
				reader.onload = (e) => {
					const data = new Uint8Array(e.target.result);
					const workbook = XLSX.read(data, { type: "array" });
					const sheetName = workbook.SheetNames[0];
					const sheet = workbook.Sheets[sheetName];
					const jsonData = XLSX.utils.sheet_to_json(sheet, {
						header: 1,
					});

					// Convert to JSON
					const headers = jsonData[0];
					const jsonDataArray = [];
					this.total_amount = 0;
					for (let i = 1; i < jsonData.length; i++) {
						const row = jsonData[i];
						const obj = {};
						for (let j = 0; j < headers.length; j++) {
							const key = headers[j]
								.replace(/\s/g, "_")
								.toLowerCase(); // Replace spaces with underscores
							let value = null;
							if (row[j]) {
								value = String(row[j]); // Convert value to string
							}
							obj[key] = value;
						}
						this.total_amount += Number(obj.commission);
						jsonDataArray.push(obj);
					}
					this.total_count = jsonDataArray.length;

					// Call showExcelUploads with the processed data
					this.showExcelUploads(jsonDataArray);
				};
				reader.readAsArrayBuffer(this.excelFile);
			} else {
				this.showExcelUploads([]); // Handle the case where no file is selected
			}
		},

		async saveBulkDeposit() {
			if (!this.form.excel_upload_id?.trim()) {
				toast.fire({ icon: "warning", title: "Enter Excel Upload ID." });
				return;
			}
			if (!this.excelFile) {
				toast.fire({ icon: "warning", title: "Choose an Excel file." });
				return;
			}
			this.message = null;
			this.isSaving = true;
			this.$Progress.start();

			const payload = new FormData();
			payload.append(
				"account_rows",
				JSON.stringify(this.account_rows)
			); // Convert to string if needed
			payload.append("excel_upload_id", this.form.excel_upload_id || "");
			if (this.payOnly) {
				payload.append("pay_commission", "pay_commission");
			} else {
				payload.append("pay_commission", this.form.pay_commission || "");
				payload.append(
					"submit_commission",
					this.form.submit_commission || ""
				);
			}
			if (this.excelFile) {
				payload.append("excelFileInput", this.excelFile);
			}
			// console.log(this.excelFile);

			await ApiService.post(
				"/accounts/imports/commission/store",
				payload
			)
				.then((response) => {
					this.$Progress.finish();
					const failUrl =
						response.data?.data?.download_url ||
						response.data?.failed_file_url ||
						response.data?.download_url;
					const msg = response.data?.message || "Import completed.";
					swal.fire({
						icon: "success",
						title: "Success",
						...(failUrl
							? {
									html: `${msg}<br/><br/><a href="${failUrl}" target="_blank" rel="noopener">Download failed rows</a>`,
							  }
							: { text: msg }),
						showCancelButton: false,
						confirmButtonText: "OK",
						buttonsStyling: false,
						customClass: {
							confirmButton:
								"btn btn-size akkurate-green-btn modal-btn-width text-white me-2",
						},
					});

					this.isSaving = false;
					this.form = this.initialState().form;
					this.account_rows = [];
					this.total_count = 0;
					this.total_amount = 0;
					this.excelFile = null;
					if (this.$refs.fileInput) {
						this.$refs.fileInput.value = "";
					}
				})
				.catch((error) => {
					this.isSaving = false;
					this.$Progress.fail();
					const errMsg =
						error.response?.data?.message ||
						error.message ||
						"Import failed.";
					this.message = errMsg;
					toast.fire({ icon: "error", title: errMsg });
				});
		},

		showExcelUploads(account_rows) {
			this.account_rows = account_rows;
		},

		initialState() {
			return {
				totalRecords: 0,
				searchFilter: "",
				total_count: 0,
				total_amount: 0,
				isLoading: true,
				isSaving: false,
				form: {
					excel_upload_id: "",
					submit_commission: "submit_commission",
					pay_commission: "",
				},
			};
		},
		downloadFile() {
			// Replace 'example.pdf' with the filename you want to download from your public directory
			const fileName = "BULK_COMMISSION_UPLOAD_TEMPLATE.xlsx";

			// console.log(fileName);

			// Construct the URL to the file in the public directory
			const fileUrl = `${config.base_url}/assets/${fileName}`;

			//   console.log(fileUrl);

			// Create a link element
			const link = document.createElement("a");
			link.href = fileUrl;
			link.download = fileName;

			// Append the link to the body
			document.body.appendChild(link);

			// Programmatically click the link to trigger the download
			link.click();

			// Remove the link from the body
			document.body.removeChild(link);
		},
	},
};
</script>
